/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PlayerPositionList = {
    type: 'array',
    contains: {
        type: 'PlayerPosition',
    },
} as const;
